var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCircle = function SvgCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5796",
    "data-name": "Grupo 5796",
    transform: "translate(-787 -327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtra\\xE7\\xE3o_11",
    "data-name": "Subtra\\xE7\\xE3o 11",
    transform: "translate(789 329)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,20A10,10,0,1,1,20,10,10,10,0,0,1,10,20Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.0001220703125 18.99982261657715 L 9.999531745910645 18.99982261657715 C 12.40317249298096 18.99839210510254 14.6629524230957 18.06162261962891 16.36258125305176 16.36206245422363 C 18.06219291687012 14.66251182556152 18.99900245666504 12.40286159515381 19.00043296813965 9.999941825866699 C 19.00043296813965 5.037391662597656 14.96291160583496 1.000061869621277 10.0001220703125 1.000061869621277 C 5.037332057952881 1.000061869621277 0.9998120665550232 5.037391662597656 0.9998120665550232 9.999941825866699 C 0.9998120665550232 14.96249198913574 5.037332057952881 18.99982261657715 10.0001220703125 18.99982261657715 M 10.0001220703125 19.99982261657715 C 4.477102279663086 19.99982261657715 -0.0001879296905826777 15.5227222442627 -0.0001879296905826777 9.999941825866699 C -0.0001879296905826777 4.477161884307861 4.477102279663086 6.182586366776377e-05 10.0001220703125 6.182586366776377e-05 C 15.52314186096191 6.182586366776377e-05 20.00043296813965 4.477161884307861 20.00043296813965 9.999941825866699 C 19.99715232849121 15.52136135101318 15.52178192138672 19.99654197692871 10.0001220703125 19.99982261657715 Z",
    stroke: "none",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1709",
    "data-name": "Ret\\xE2ngulo 1709",
    width: 24,
    height: 24,
    transform: "translate(787 327)",
    fill: "none"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circle.2d477d9b.svg";
export { ForwardRef as ReactComponent };